import React from "react";

/**
 * Small read-only chips for coach-managed event tags. Renders nothing when
 * there are no tags; `max` caps how many are shown (with a "+n" overflow).
 */
const EventTagChips: React.FC<{
  tags: string[] | undefined;
  max?: number;
  className?: string;
}> = ({ tags, max, className = "" }) => {
  if (!tags || tags.length === 0) return null;
  const shown = max !== undefined ? tags.slice(0, max) : tags;
  const extra = tags.length - shown.length;
  return (
    <div className={`flex flex-wrap items-center gap-1 ${className}`}>
      {shown.map((tag, i) => (
        <span
          key={`${tag}-${i}`}
          className="inline-flex max-w-[10rem] items-center truncate rounded-full bg-base-content/10 px-2 py-0.5 text-[10px] font-medium text-base-content/70 font-grotesk"
        >
          {tag}
        </span>
      ))}
      {extra > 0 && (
        <span className="text-[10px] font-medium text-base-content/50 font-grotesk">
          +{extra}
        </span>
      )}
    </div>
  );
};

export default EventTagChips;
